import { render, staticRenderFns } from "./InlineIcon.vue?vue&type=template&id=6af1c8f7&"
import script from "./InlineIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InlineIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports